/*
 * Copyright (c) 2023 Anvilor Solutions LLC - All Rights Reserved.
 *
 * The information and source code contained herein is the exclusive property of
 * Anvilor Solutions LLC and may not be disclosed, examined, or reproduced in whole
 * or in part without the explicit written authorization from Anvilor Solutions LLC.
 */

export const ANVILOR_SURVEYS_FAVICON_PATH =
  "https://anvilorsolutions-static.azureedge.net" +
  "/anvilor/anvilor-forms/anvilor-forms-favicon-default.png";

export const EXIT_APP_REDIRECT_URL = "https://anvilor.com";
export const EDIT_KEY_QPARAM = "edit_key";
